import { AxiosError } from 'axios';
import React, { useState, useReducer } from 'react';
import { Nullable } from 'types/utilityTypes';

let userId = localStorage.getItem('currentUser')
	? JSON.parse(localStorage.getItem('currentUser') || "").userId
	: '';
let user = localStorage.getItem('currentUser')
	? JSON.parse(localStorage.getItem('currentUser') || "").user
	: '';
let token = localStorage.getItem('currentUser')
	? JSON.parse(localStorage.getItem('currentUser') || "").auth_token
	: '';   

export const initialState:authStateType = {
	userId:'' || userId,
	user: '' || user,
	token: '' || token,
	loading: false,
	errorMessage: null,
    tokenExpires: '' || null,
	connection: null
};

export type authStateType = Partial<
Nullable<{
	userId: string | null;
	user: string | null;
    token: string | null;
	loading: boolean | null;
	errorMessage : string | null;
    tokenExpires : number | null;
	connection : signalR.HubConnection | null;
}> >;

export type  payloadType = Partial<
Nullable<{ 
	user: authStateType | null; 
	auth_token: string | null; 
}>>; 

export type authActionsType = Partial<
  Nullable<{
    type: string | null ; payload: payloadType | null ; error:  Error | AxiosError | null; userId: string | null;
  }>  
>;


export  const AuthReducer = (initialState: any | null, action: any ) => {
	switch (action.type) {
		case 'REQUEST_LOGIN':
			return {
				...initialState,
				loading: true,                
			};
		case 'LOGIN_SUCCESS':
			return {
				...initialState,
				userId: action?.payload?.user.userId,
				user: action?.payload?.user.user,
				token: action?.payload?.auth_token,
				loading: false,
                tokenExpires: action?.payload?.user.token_expires
			};
		case 'LOGOUT':
			return {
				...initialState,
				userId: '',
				user: '',
				token: '',
                tokenExpires: '',
			};

		case 'LOGIN_ERROR':
			return {
				...initialState,
				loading: false,
				errorMessage: action.error,
			};

			case 'SET_CONNECTION' : 
			return {
				...initialState,
				connection : action.connection,
			}

			case 'SET_USER_ID' :
				return{
					...initialState,
				userId : action.userId,
				}

		default:
			throw new Error(`Unhandled action type: ${action.type}`);
	}
};